import { useApp } from '@/hooks/useApp'
import { useGetGrouppedAvailablePackages, useGetOfferAvailablePackageItems, useUpdateOfferPackage } from '@/hooks/useOfferPackage'
import { Box, Button, Heading, HStack, Radio, RadioGroup, Stack } from '@chakra-ui/react'
import { type OfferPackage, type OfferProperty } from 'BrokerTsLib/src/dtos'
import { Product } from 'BrokerTsLib/src/enums'
import { useState } from 'react'

const GetGroups = (product: Product): { [groupId: string]: string } => {
  switch (product) {
    case Product.PropertyInsurance:
      return {
        '0': 'Odpovědnost',
        '1': 'Stavba',
        '2': 'Domácnost',
        '5': 'Odpovědnost',
      }
    // ostatni maji jen jednu kategorii, takze textace neresim
    case Product.LiabilityInsurance:
    case Product.TravelInsurance:
    default:
      return {
        '0': '',
      }
  }
}

const GetGroupSelectedValues = (offer: OfferPackage): { [groupId: string]: string } => {
  return {
    '0': offer.liabilityPackageId?.toString() ?? '',
    '1': offer.realtyPackageId?.toString() ?? '',
    '2': offer.householdPackageId?.toString() ?? '',
    '5': offer.liabilityPackageId?.toString() ?? '',
  }
}

export const OfferPackageSettingsFormPackages = ({
  offer,
  isReadOnly,
  submitCallback
}: {
  offer: OfferPackage | OfferProperty,
  isReadOnly: boolean,
  submitCallback?: () => void
}) => {
  const { product, app } = useApp()
  const groups = GetGroups(product!)
  const origValues = GetGroupSelectedValues(offer)
  const [selectedValues, setSelectedValues] = useState(origValues)

  const { refetch: getOfferAvailablePackageItems } = useGetOfferAvailablePackageItems(offer!.offerId)
  const groupedAvailablePackages = useGetGrouppedAvailablePackages(offer.offerId)
  const { mutateAsync: updatePackage } = useUpdateOfferPackage()

  const [isLoading, setIsLoading] = useState(false)

  const submitForm = async () => {
    setIsLoading(true)

    const packages = Object.entries(selectedValues)
      .map(([groupKey, packageId]) => {
        return {
          groupId: parseInt(groupKey),
          packageId: parseInt(packageId)
        }
      })
      .filter(item => item.packageId > 0 && origValues[item.groupId] !== item.packageId.toString())


    const DOMACNOST_ID = 2
    const ODPOVEDNOST_ID = 5

    // Zjistíme, zda se mění domácnost
    const domacnost = packages.find(p => p.groupId === DOMACNOST_ID);
    // Zjistíme, zda je odpovědnost v seznamu měnitelných (zobrazených) polí
    const isOdpovednostEditable = !!groupedAvailablePackages[ODPOVEDNOST_ID];

    // Pokud měním domácnost a zároveň NEMÁM možnost měnit odpovědnost samostatně
    if (domacnost && !isOdpovednostEditable && !!origValues[ODPOVEDNOST_ID]) {
      // Přidáme změnu odpovědnosti na stejné ID balíčku, jako má domácnost      
      packages.push({
        groupId: ODPOVEDNOST_ID,
        packageId: domacnost.packageId
      });
    }
    // Pokud lze menit jen JEDNU kategorii, tak aut. zmenim i ostatni na stejny balicek (napriklad menim samostatny balicek stavby, ale balicek odpovednosti menit nelze)
    else if (Object.keys(groupedAvailablePackages).length === 1 && packages.length === 1) {
      const groupKey = packages[0].groupId
      const packageId = packages[0].packageId

      Object.keys(origValues)
        .filter(origGroupKey => origGroupKey.toString() !== groupKey.toString() && !!origValues[origGroupKey])
        .forEach(gk => {
          packages.push({
            groupId: parseInt(gk),
            packageId: packageId
          })
        })
    }

    await updatePackage({ offerId: offer.offerId, packages: packages })

    await getOfferAvailablePackageItems()

    setIsLoading(false)

    submitCallback?.()
  }

  const changed = Object.keys({ ...origValues, ...selectedValues }).some(
    groupId => origValues[groupId] !== selectedValues[groupId]
  )

  console.log('groupedAvailablePackages', groupedAvailablePackages, 'selectedValues', selectedValues, 'groups', groups, 'offer', offer)

  return (
    <>
      <Stack>
        {Object.entries(groupedAvailablePackages)
          .sort((x, y) => {
            const groupX = x[1][0].groupOrder
            const groupY = y[1][0].groupOrder
            return (groupX ?? 0) - (groupY ?? 0)
          })
          .map(([groupKey, items]) => (
            <Box key={groupKey} mb={8}>
              <Heading size="md" mb={4}>{groups[groupKey]}</Heading>

              <RadioGroup
                value={selectedValues[groupKey]?.toString() || ''}
                onChange={(val) => setSelectedValues(prev => ({ ...prev, [groupKey]: val }))}
              >
                <HStack spacing={2} gap={6}>
                  {items.map(item => (
                    <Radio key={item.id} value={item.id.toString()} isDisabled={isReadOnly}>
                      {item.name}
                    </Radio>
                  ))}
                </HStack>
              </RadioGroup>
            </Box>
          ))}

        {!isReadOnly &&
          <Button
            ml='auto'
            isDisabled={isLoading || !changed}
            isLoading={isLoading}
            colorScheme="green"
            onClick={submitForm}>
            Uložit
          </Button>
        }
      </Stack>
    </>
  )
}